const defaultState = {
    signatureType: "detached",
    cadesType: "CAdESXLong"
}

const deleteReducer = (state = defaultState, { type, payload }) => {

    switch (type) {
        case 'SET_SIGNATURE_TYPE_DELETE': {
            return {
                ...state,
                signatureType: payload
            }
        }

        case 'SET_CADES_TYPE_DELETE': {
            return {
                ...state,
                cadesType: payload
            }
        }

        default:
            return state;
    }

}

export default deleteReducer